import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import CategoryHeading from '@fuww/components/src/CategoryHeading';
import SpacingContainer
from '@fuww/components/src/SpacingContainer';
import breakpoints from '@fuww/components/src/Theme/breakpoints';
import { RelatedNewsContainer, RelatedNewsItem }
from '@fuww/components/src/List/RelatedNews';
import CardWithLink from '../../CardWithLink';
import getArticlesQuery from '../../../lib/queries/news/getArticlesQuery';
import getArticlesField from '../../../lib/queries/news/getArticlesField';
import {
  relatedCategoryIds as categoryIds,
} from '../../../lib/mainCategoryIds';
import withQuery from '../../../lib/withQuery';
import SiteContext from '../../SiteContext';
import messages from '../../../lib/messages';

const imageConfigurations = [
  {
    width: 42,
    height: 28,
    quality: 10,
    resize: 'FILL_DOWN',
  },
  { width: 220, height: 147, resize: 'FILL_DOWN' },
  { width: 440, height: 293, resize: 'FILL_DOWN' },
  { width: 720, height: 480, resize: 'FILL_DOWN' },
];

const RelatedNews = ({
  data, variables, field,
}) => {
  const articles = data[field];
  const intl = useIntl();

  return (
    <>
      <CategoryHeading>
        {intl.formatMessage(messages.relatedNews)}
      </CategoryHeading>
      <SpacingContainer />
      <RelatedNewsContainer>
        {articles.map((article) => (
          <RelatedNewsItem key={article.id}>
            <CardWithLink
              newsArticle={article}
              variables={variables}
              withPageMargins
              sizes={`
                (min-width: 1100px) 220px,
                (min-width: ${breakpoints.lg}px) 21vw,
                (min-width: ${breakpoints.sm}px) 31vw,
                100vw
              `}
            />
          </RelatedNewsItem>
        ))}
      </RelatedNewsContainer>
    </>
  );
};

RelatedNews.propTypes = {
  data: PropTypes.shape({}),
  variables: PropTypes.shape({}).isRequired,
  field: PropTypes.string.isRequired,
};

RelatedNews.defaultProps = {
  data: {},
};

const RelatedNewsWithQuery = withQuery(RelatedNews);

const errorMessage = 'Error while loading news articles...';

const RelatedNewsWithData = ({
  articleId, keywords, showImage, showCategory, noBorderFirstItem,
}) => {
  const { prefix, hasLocalNews, newsboard } = useContext(SiteContext);

  const field = getArticlesField(prefix, hasLocalNews);
  const query = getArticlesQuery(field, 'withSummaryAndLabel');
  const variables = {
    sort: 'CREATED_AT',
    limit: 3,
    newsboards: [newsboard],
    keywords,
    notInIds: articleId,
    categoryIds,
    imageConfigurations,
  };

  return (
    <RelatedNewsWithQuery
      query={query}
      variables={variables}
      errorMessage={errorMessage}
      field={field}
      showCategory={showCategory}
      showImage={showImage}
      noBorderFirstItem={noBorderFirstItem}
    />
  );
};

RelatedNewsWithData.propTypes = {
  keywords: PropTypes.arrayOf(PropTypes.string),
  articleId: PropTypes.number,
  showImage: PropTypes.bool,
  showCategory: PropTypes.bool,
  noBorderFirstItem: PropTypes.bool,
};

RelatedNewsWithData.defaultProps = {
  articleId: null,
  keywords: null,
  showImage: null,
  showCategory: null,
  noBorderFirstItem: null,
};

export default RelatedNewsWithData;
